import { IGetCarga } from 'src/app/services/CargaService/carga.model';

const TIPO_CARGA_AGRO = 0;

export function isCargaGrao(carga?: IGetCarga | null): boolean {
  if (!carga?.TX_CRGA) {
    return false;
  }

  const tx = carga.TX_CRGA.trim();
  if (/fertil/i.test(tx)) {
    return false;
  }

  if (/gr[ãa]o/i.test(tx)) {
    return true;
  }

  return carga.NU_TIPO_CRGA === TIPO_CARGA_AGRO;
}

export function getInicioJanelaAgendada(
  dtAgnd: string | Date,
  hrInicJanela?: string | null
): Date | null {
  const base = new Date(dtAgnd);
  if (Number.isNaN(base.getTime())) {
    return null;
  }

  if (!hrInicJanela?.trim()) {
    return base;
  }

  const [h, m] = hrInicJanela.split(':').map(Number);
  if (Number.isNaN(h) || Number.isNaN(m)) {
    return base;
  }

  return new Date(base.getFullYear(), base.getMonth(), base.getDate(), h, m, 0);
}
